import { createReducer, on } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { GlossarioOutputDto } from "src/app/domain/DTOs/output/glossario.output.dto";
import { obterGlossario, obterGlossarioSuccess, obterGlossarioFailure, obterGlossarioFinish } from "../actions/glossario.action";

export interface ObterGlossarioState {
    response: EstruturaRetornoDadosOutputDto<GlossarioOutputDto[]> | null;
    error: string[] | null;
}

export const initialState: ObterGlossarioState = {
    response: null,
    error: null,
};

export const ObterGlossarioReducer = createReducer(
    initialState,
    on(obterGlossario, state => ({ ...state, error: null })),
    on(obterGlossarioSuccess, (state, { response }) => ({ ...state, response, error: null })),
    on(obterGlossarioFailure, (state, { response }) => ({ ...state, response: null, error: response.erros })),
    on(obterGlossarioFinish, state => ({ ...state, response: null, error: null }))
);